import { z } from "zod";

import { RechargeGlobalSettingsDtoSchema } from "../../../../dtos/recharge-integrations";

export const PatchRechargeRequestBodySchema = z.object({
  recharge: RechargeGlobalSettingsDtoSchema.extend({
    enabled: z.boolean(),
    id: z.string().uuid(),
  }),
});
export type PatchRechargeRequestBodyType = z.infer<
  typeof PatchRechargeRequestBodySchema
>;
